export const LEADERBOARD_FILE_KEYS = [
  'sponsor_logo_1',
  'sponsor_logo_2',
  'sponsor_logo_3',
  'sponsor_logo_desktop',
  'sponsor_logo_mobile'
]

export const NOMINATIONS_FILE_KEYS = [
  'sponsor_logo_1',
  'sponsor_logo_2',
  'sponsor_logo_desktop',
  'sponsor_logo_mobile'
]

export const FRAME_CONFIG = {
  leaderboard: {
    title: 'Leaderboard Appearance',
    logoCount: 3,
    hasLogoLinks: true,
    fileKeys: LEADERBOARD_FILE_KEYS
  },
  nominations: {
    title: 'Nominations Appearance',
    logoCount: 2,
    hasLogoLinks: false,
    fileKeys: NOMINATIONS_FILE_KEYS
  }
}



// WEBPACK FOOTER //
// ./src/composables/appearances/constants.js